/**
 * Created by lobin on 2019/1/15.
 */
import anchor from "./anchor.vue";
import pagination from "./pagination.vue";
import prompt from "./prompt.vue";

import Vue from "vue";
Vue.component("el-anchor", anchor);
Vue.component("pagination", pagination);
Vue.component("prompt", prompt);

import VueScrollactive from "vue-scrollactive";
Vue.use(VueScrollactive);
import VueQuillEditor from "vue-quill-editor";

// require styles
import "quill/dist/quill.core.css";
import "quill/dist/quill.snow.css";
import "quill/dist/quill.bubble.css";

Vue.use(VueQuillEditor, {
  theme: "snow",
  boundary: document.body,
  modules: {
    toolbar: [
      // ['bold', 'italic', 'underline', 'strike'],
      // ['blockquote', 'code-block'],
      // [{ 'header': 1 }, { 'header': 2 }],
      [{ list: "ordered" }, { list: "bullet" }]
      // [{ 'script': 'sub' }, { 'script': 'super' }],
      // [{ 'indent': '-1' }, { 'indent': '+1' }],
      // [{ 'direction': 'rtl' }],
      // [{ 'size': ['small', false, 'large', 'huge'] }],
      // [{ 'header': [1, 2, 3, 4, 5, 6, false] }],
      // [{ 'color': [] }, { 'background': [] }],
      // [{ 'font': [] }],
      // [{ 'align': [] }],
      // ['clean'],
      // ['link', 'image', 'video']
    ]
  },
  placeholder: "请输入内容 ...",
  readOnly: false
});
